import { useState } from 'react'
import { collectReport } from './report/collectReport'

const FAIL_COPY = 'We couldn’t prepare the PDF just now. Please try again.'

/**
 * "Download Kundli" — the full studio (every tab's records plus the Lagna D1
 * and Navamsha D9 charts) as one PDF. jsPDF loads only on the first click, so
 * the studio itself stays light. A failure turns the button into its own
 * retry, flagged with a small badge + tooltip rather than a banner.
 */
export default function DownloadKundliButton({ birth }) {
  const [busy, setBusy] = useState(false)
  const [failed, setFailed] = useState(false)

  const download = async () => {
    if (busy || !birth) return
    setBusy(true)
    setFailed(false)
    try {
      const [{ buildKundliPdf, reportFileName }, report] = await Promise.all([
        import('./report/buildKundliPdf'),
        collectReport(birth),
      ])
      const doc = await buildKundliPdf(report)
      doc.save(reportFileName(birth))
    } catch (err) {
      console.error('[kundli-studio] PDF export failed', err)
      setFailed(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <button
      type="button"
      className={`ks-download${failed ? ' is-failed' : ''}`}
      onClick={download}
      disabled={busy || !birth}
      aria-busy={busy}
      title={failed ? FAIL_COPY : 'Download the complete Kundli with Lagna D1 & Navamsha D9 charts as a PDF'}
    >
      {busy ? <span className="ks-download-spin" aria-hidden="true" /> : <span aria-hidden="true">⬇</span>}
      <span className="ks-download-long">{busy ? 'Preparing PDF…' : failed ? 'Try Download Again' : 'Download Kundli'}</span>
      <span className="ks-download-short">{busy ? '…' : 'PDF'}</span>
      {failed && !busy && (
        <span className="ks-download-alert" aria-label={FAIL_COPY}>!</span>
      )}
    </button>
  )
}
